<template>
  <div>
    <div class="popup">
      <div class="bg-mask" @click="close"></div>
      <div class="popup-content" @click.self="close">
        <div class="popup-content__wrapper">
          <video width="100%" height="100%" controls autoplay>
            <source :src="videoSrc" :type="videoType" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <div class="close-button" @click="close">
        <svg
          width="57"
          height="57"
          viewBox="0 0 57 57"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.8552 1.67571C48.5082 3.33827 53.6568 8.4999 55.321 15.1425C57.5212 24.0155 57.5294 33.0175 55.3314 41.8428L55.3289 41.8533C53.7039 48.4762 48.525 53.6451 41.8859 55.308C37.4415 56.4097 32.9646 56.9751 28.518 56.9754C24.0614 56.9757 19.5852 56.428 15.1711 55.3251C8.5173 53.6625 3.36845 48.4997 1.70481 41.8558L1.70351 41.8507C-0.527411 33.0048 -0.536903 24.009 1.69263 15.1672L1.69484 15.1584C3.35314 8.50091 8.50793 3.35409 15.1412 1.69263C19.5854 0.591221 24.062 0.0257076 28.5085 0.0253908C32.965 0.0250748 37.4412 0.57287 41.8552 1.67571ZM38.8874 7.63676C44.062 8.92987 48.0665 12.9445 49.3609 18.1109C51.0719 25.0122 51.0785 32.0136 49.3688 38.8779L49.3669 38.8859C48.1029 44.0373 44.0749 48.0573 38.9112 49.3507C35.4546 50.2075 31.9724 50.6473 28.5141 50.6476C25.0478 50.6479 21.5663 50.2218 18.1332 49.364C12.958 48.0709 8.95331 44.0553 7.65938 38.8878L7.65837 38.884C5.92319 32.0038 5.91582 25.0071 7.64992 18.1302L7.65163 18.1233C8.94142 12.9453 12.9507 8.94215 18.1099 7.64992C21.5665 6.79327 25.0483 6.35342 28.5067 6.35317C31.9728 6.35292 35.4543 6.779 38.8874 7.63676ZM39.2811 19.9556C40.0427 19.1936 40.0427 17.9583 39.2811 17.1963C38.5193 16.4344 37.2844 16.4344 36.5229 17.1964L28.4129 25.3094L19.6837 16.5769C18.8494 15.7423 17.4968 15.7423 16.6626 16.5769C15.8283 17.4115 15.8283 18.7647 16.6626 19.5992L25.3917 28.3317L16.3578 37.369C15.5962 38.1309 15.5962 39.3664 16.3578 40.1283C17.1195 40.8901 18.3544 40.8901 19.116 40.1283L28.1499 31.091L36.5647 39.5089C37.399 40.3436 38.7516 40.3436 39.5859 39.5089C40.4199 38.6743 40.4199 37.3211 39.5859 36.4865L31.1712 28.0686L39.2811 19.9556Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      videoSrc: {
        type: [File, String],
        required: true
      },
      videoType: {
        type: String,
        default: 'video/mp4'
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  .popup {
    position: fixed;
    z-index: 200;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .bg-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(4, 9, 19, 0.7);
      cursor: pointer;
    }
    .popup-content {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      max-width: 1440px;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      cursor: pointer;
      &__wrapper {
        cursor: default;
        flex-grow: 1;
        padding-bottom: 56%;
        position: relative;
        background: black;
        video {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }

        @media screen and (min-width: 990px) and (max-width: 1600px) {
          margin: 50px 100px;
          padding-bottom: 50%;
        }
        @media screen and (min-width: 600px) and (max-width: 990px) {
          margin: 37px 100px;
          padding-bottom: 53%;
        }
      }
    }

    .close-button {
      position: absolute;
      top: 35px;
      right: 48px;
      width: 57px;
      height: 57px;
      cursor: pointer;
      svg {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      @include respond-to(tabletRotate) {
        width: 46px;
        height: 46px;
        right: 38px;
      }
      @include respond-to(mobileRotate) {
        width: 34px;
        height: 34px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoPopup.vue